
<template>
  <div>
    <!-- Begin Mailchimp Signup Form -->

    <div id="mc_embed_signup">
      <form
        action="https://risadsaluddigital.us13.list-manage.com/subscribe/post?u=8b530fa9ddc4c1fc83287919c&amp;id=bcd3460e98&amp;f_id=00fcf3e7f0" 
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        class="validate"
        target="_blank"
        novalidate
      >
        <div id="mc_embed_signup_scroll">
          <label for="mce-EMAIL"> </label>
          <input
            type="email"
            value=""
            name="EMAIL"
            class="email"
            id="mce-EMAIL"
            required
          />
          <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true">
            <input
              type="text"
              name="b_5119408c70596654ef4da6c1a_987baf3d10"
              tabindex="-1"
              value=""
            />
          </div>
          <div class="clear">
            <input
              type="submit"
              value="Subscribete"
              name="subscribe"
              id="mc-embedded-subscribe"
              class="button"
            />
          </div>
        </div>
      </form>
    </div>

    <!--End mc_embed_signup-->
  </div>
</template>

<script>
export default {
  name: "SignupForm",
  components: {}
};
</script>
